<template>
  <tfoot class="mt-1">
    <tr>
      <td
        scope="col"
        class="flex flex-row items-center gap-2 text-platform-text-2"
      >
        <BaseIcon name="automatic" />
        <p class="text-xs">{{ $t("product.automaticBid") }}</p>
      </td>
    </tr>
  </tfoot>
</template>
